/* eslint-disable */
import { useCallback, useEffect } from "react";
import { Formik, Form } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardContent, Grid } from "@mui/material";
import LanguageSelect from "./LanguageSelect";

import FormField from "components/FormField";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import brandWhite from "assets/images/logo-without-modules.png";

import { actions } from "store/reducers/qrCodeClockIn";
import getValidations from "./schemas/validations";
import formSchema from "./schemas/form";
import initialValues from "./schemas/initialValues";
import { useTranslation } from "react-i18next";

function LogInForm({ values, errors, touched, isSubmitting, setErrors, t }) {
  const {
    formId,
    formField: { auth, code },
  } = formSchema;
  const error = useSelector((state) => state.qrCodeClockIn.loggingInError);
  useEffect(() => {
    setErrors({
      [code.name]: error,
      [auth.name]: error,
    });
  }, [error, setErrors]);

  return (
    <Form id={formId}>
      <MDBox>
        <MDBox mb={3}>
          <Grid container justifyContent="center">
            <Grid item>
              <img height={70} src={brandWhite} alt="logo" />
            </Grid>
          </Grid>
        </MDBox>

        <MDBox mb={3}>
          <Grid container justifyContent="space-between">
            <Grid item>
              <MDTypography variant="h5" fontWeight="medium" textTransform="capitalize">
                {t("Login")}
              </MDTypography>
            </Grid>

            <Grid item>
              <LanguageSelect />
            </Grid>
          </Grid>
        </MDBox>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormField
              type={code.type}
              label={t(code.label)}
              name={code.name}
              value={values.code}
              placeholder={t(code.placeholder)}
              error={errors.code && touched.code}
              success={values.code.length > 0 && !errors.code}
              inputProps={{ autoComplete: "", inputMode: "numeric" ,pattern: "[-+]?[0-9]*[.,]?[0-9]+" }}
            />
          </Grid>

          <Grid item xs={12}>
            <FormField
              type={auth.type}
              label={t(auth.label)}
              name={auth.name}
              value={values.auth}
              placeholder={t(auth.placeholder)}
              error={errors.auth && touched.auth}
              success={values.auth.length > 0 && !errors.auth}
              inputProps={{ autoComplete: "", inputMode: "numeric" ,pattern: "[-+]?[0-9]*[.,]?[0-9]+" }}
            />
          </Grid>
        </Grid>
      </MDBox>

      <MDBox mt={4} mb={1}>
        <MDButton disabled={isSubmitting} type="submit" variant="gradient" color="info" fullWidth>
          {t("SIGN IN")}
        </MDButton>
      </MDBox>
    </Form>
  );
}

function LogIn() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const submitForm = useCallback(
    (data, { setSubmitting }) => {
      const cb = () => setSubmitting(false);
      dispatch(actions.requestClockInLogin(data, cb, cb));
    },
    [dispatch]
  );
  const validations = getValidations(t);

  return (
    <Card>
      <CardContent>
        <MDBox mt={3}>
          <Formik
            initialValues={initialValues}
            validationSchema={validations}
            onSubmit={submitForm}
          >
            {(formikHelpers) => <LogInForm {...formikHelpers} t={t} />}
          </Formik>
        </MDBox>
      </CardContent>
    </Card>
  );
}

export default LogIn;
